import { render } from "./SectionContainer.vue?vue&type=template&id=761ab4c3&scoped=true"
import script from "./SectionContainer.vue?vue&type=script&lang=js"
export * from "./SectionContainer.vue?vue&type=script&lang=js"

import "./SectionContainer.vue?vue&type=style&index=0&id=761ab4c3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761ab4c3"]])

export default __exports__